export const NEW_ERROR = "addError";
export const RESET_ERRORS = "clearErrors";
